"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceTypeEnum = exports.ResourceRoleEnum = exports.ResourceStatusEnum = void 0;
var ResourceStatusEnum;
(function (ResourceStatusEnum) {
  ResourceStatusEnum["STATUS_ACTIVE"] = "STATUS_ACTIVE";
  ResourceStatusEnum["STATUS_PARKED"] = "STATUS_PARKED";
  ResourceStatusEnum["STATUS_NON_BOOKABLE"] = "STATUS_NON_BOOKABLE";
  ResourceStatusEnum["STATUS_ARCHIVED"] = "STATUS_ARCHIVED";
})(ResourceStatusEnum || (exports.ResourceStatusEnum = ResourceStatusEnum = {}));
var ResourceRoleEnum;
(function (ResourceRoleEnum) {
  ResourceRoleEnum["ROLE_OWNER"] = "ROLE_OWNER";
  ResourceRoleEnum["ROLE_ADMIN"] = "ROLE_ADMIN";
  ResourceRoleEnum["ROLE_ACCOUNT_HANDLER"] = "ROLE_ACCOUNT_HANDLER";
  ResourceRoleEnum["ROLE_ACCOUNT_HANDLER_1"] = "ROLE_ACCOUNT_HANDLER_1";
  ResourceRoleEnum["ROLE_TEAM"] = "ROLE_TEAM";
  ResourceRoleEnum["ROLE_CONTRACTOR"] = "ROLE_CONTRACTOR";
})(ResourceRoleEnum || (exports.ResourceRoleEnum = ResourceRoleEnum = {}));
var ResourceTypeEnum;
(function (ResourceTypeEnum) {
  ResourceTypeEnum["UNASSIGNED"] = "UNASSIGNED";
  ResourceTypeEnum["REGULAR"] = "REGULAR";
})(ResourceTypeEnum || (exports.ResourceTypeEnum = ResourceTypeEnum = {}));